module.exports = __webpack_public_path__ + "static/img/Anniko.fb72944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Anniko.jpg
// module id = kiFe
// module chunks = 1